import { Fragment, h, JSX } from 'preact';

export interface SelectOption {
    value: string;
    label: string;
    attributes?: JSX.HTMLAttributes<HTMLOptionElement>;
}

export interface SelectProps {
    label?: string;
    id?: string;
    name?: string;
    value: string;
    onChange: (value: string) => void;
    required?: boolean;
    disabled?: boolean;
    options: SelectOption[];
}

export const Select = (props: SelectProps): JSX.Element => (
    <Fragment>
        {props.label && (
            <label for={props.id}>
                {props.label}
            </label>
        )}
        <div class='flex-1 min-w-0'>
            <select
                class='text-gray-900 block w-full h-12 transition duration-75 rounded-lg shadow-sm outline-none focus:border-primary-500 focus:ring-1 focus:ring-inset focus:ring-primary-500 disabled:opacity-70 border-gray-300'
                id={props.id}
                name={props.name}
                value={props.value}
                onChange={(event): void => props.onChange(event.currentTarget.value)}
                required={props.required}
                disabled={props.disabled}
            >
                {props.options.map((option) => (
                    <option value={option.value} {...option.attributes}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    </Fragment>
);
